import gql from 'graphql-tag';

export class CommentsFragments {
  static participant = gql`
    fragment participantFragment on CommentParticipant {
      recipientId
      userId
    }
  `;

  static reply = gql`
    fragment replyFragment on CommentReply {
      id
      richText
      text
      status
      createdAt
      updatedAt
      reads {
        participant {
          ...participantFragment
        }
        timestamp
      }
      createdBy {
        ...participantFragment
      }
      mentions {
        ...participantFragment
      }
    }
    ${this.participant}
  `;

  static textSelection = gql`
    fragment textSelectionFragment on TextSelection {
      anchor
      head
      type
    }
  `;

  static editorSelection = gql`
    fragment selectionFragment on EditorSelection {
      commentId
      editorBlockId
      rowId
      cellId
      nodeId
      sectionId
      content
      detachedFromContent
      editorBlockVersion
      textSelection {
        ...textSelectionFragment
      }
    }
    ${this.textSelection}
  `;

  static comment = gql`
    fragment commentFragment on ContextualComment {
      id
      richText
      text
      status
      createdAt
      updatedAt
      pageId
      createdBy {
        ...participantFragment
      }
      editorSelection {
        ...selectionFragment
      }
      replies {
        ...replyFragment
      }
      reads {
        participant {
          ...participantFragment
        }
        timestamp
      }
    }
    ${this.participant}
    ${this.editorSelection}
    ${this.reply}
  `;
}
